import cx from "classnames";
import { Icon } from "common/Icon";
import { RouteThumb } from "common/ListItems";
import { Distance, Elevation } from "common/units";
import moment from "moment";
import React from "react";
import { DeleteExperienceRouteDialogContainer } from "../../../dialogs/DeleteExperienceRouteDialog";
import styles from "./ExperienceRoute.scss";

export class ExperienceRoute extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteDialog: false,
    };
  }
  deleteClicked = () => {
    this.setState({ showDeleteDialog: true });
  };

  hideDeleteDialog = () => {
    this.setState({ showDeleteDialog: false });
  };

  render() {
    const {
      route,
      experienceRoute,
      dragHandleProps,
      onSelect,
      hoverDisabled,
      isDragging,
      selected,
      editable,
      preview,
    } = this.props;
    const { showDeleteDialog } = this.state;

    return (
      <div
        className={cx(
          styles.ExperienceRoute,
          preview && styles.preview,
          selected && styles.selected,
          hoverDisabled || styles.hoverEffects,
          isDragging && styles.isDragging
        )}
      >
        <div onClick={preview ? null : onSelect}>
          <h3>{route.name}</h3>
          <div className={styles.details}>
            <div>
              {route.locality}, {route.administrativeArea}
            </div>
            <div>
              <Distance value={route.distance} />
            </div>
            <div>
              <Elevation value={route.elevationGain} />
            </div>
          </div>
          <div className={styles.created}>{moment(route.createdAt).format("YYYY-MM-DD")}</div>
        </div>
        {preview && (
          <div className={styles.routeThumb}>
            <RouteThumb route={route} />
          </div>
        )}
        <div style={{ display: editable ? "" : "none" }} className={styles.controls}>
          <a style={{ color: "inherit" }} href={`/routes/${route.id}`} target="_blank">
            <Icon i="md-open" size={18} />
          </a>
          <Icon i="md-trash" size={18} onClick={this.deleteClicked} />
          <Icon i="md-move" size={18} {...dragHandleProps} />
        </div>
        {showDeleteDialog && (
          <DeleteExperienceRouteDialogContainer
            experienceRoute={experienceRoute}
            route={route}
            onRequestClose={this.hideDeleteDialog}
          />
        )}
      </div>
    );
  }
}
